/**
 * The lists area's two routes, aggregated.
 *
 * An aggregate array takes the PLURAL `*.routes.tsx` name; a single
 * `RouteObject` takes `*.route.tsx`. The importer knows the shape from the
 * name, which is the whole point of the rule.
 *
 * Order matters to the matcher only where two patterns could both match; here
 * `lists` and `lists/:slug` are disjoint, and the pair is listed in sitemap
 * order so the file reads the way the surface does.
 */
import type { RouteObject } from 'react-router-dom';

import { collectionRoute } from './collection/collection.route';
import { listsIndexRoute } from './index/lists-index.route';

export const listsRoutes: RouteObject[] = [listsIndexRoute, collectionRoute];
